import * as React from 'react'
import { FC } from 'react'
import { ErrorMessaging } from './ErrorMessaging'
import { ILeadOppProduct } from '@user/store/leadOppProducts/typings'
import { TemplateDetails } from './Details'
import { ServiceList } from './ServiceList'
import { ENTITY_TYPES } from '@sales-center/common'
import { ITemplateDetail } from '@user/store/agreements'
import { TemplateError } from '../../typings'

import Box from '@mui/material/Box'
import { CreateLocationError } from './CreateLocationError'
import { DetailsCheckbox } from './DetailsCheckbox'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES

  templateId: number | ''
  isLoading: boolean
  template: ITemplateDetail | null
  templateError: TemplateError

  services: ILeadOppProduct[]
  openServicesDrawer: () => void
  openCreateServiceDrawer: () => void
  showPestPacLocationError?: boolean | null
}

export const DetailsWrapper: FC<Props> = (props) => {
  const {
    templateId,
    template,
    isLoading,
    showPestPacLocationError,
    templateError: { exceedsServiceSlots, exceedsServiceLocations },
  } = props

  const showCheckbox =
    !isLoading &&
    !!templateId &&
    !!template &&
    template.dynamicServiceBlock &&
    !template.willDynamicServiceBlockFit

  return (
    <Box>
      <CreateLocationError {...props} />
      {!!templateId && (
        <>
          {!showPestPacLocationError && (
            <>
              <ErrorMessaging {...props} />
              {showCheckbox && <DetailsCheckbox />}
            </>
          )}

          <TemplateDetails
            details={template}
            isLoading={isLoading}
            templateId={templateId}
            hasError={
              exceedsServiceSlots ||
              exceedsServiceLocations ||
              !!showPestPacLocationError
            }
          />
        </>
      )}

      <ServiceList {...props} />
    </Box>
  )
}
DetailsWrapper.displayName = 'DetailsWrapper'
